import { resourceServer, localResourceServer } from '../config/common'
import cfg from '../config/config'
import {Base64} from 'js-base64'

export const isObject = arg => {
    return arg != null && typeof arg == 'object'
}

export const isArray = arg => {
    return isObject(arg) && arg.constructor == Array
}

export const isFunction = arg => {
    return typeof arg == 'function'
}

export const isNumber = arg => {
    return typeof arg == 'number' && !isNaN(arg)
}

export const isBoolean = arg => {
    return typeof arg == 'boolean'
}

export const isString = arg => {
    return typeof arg == 'string'
}

export const isEmpty = arg => {
    if (typeof arg == 'undefined' || arg == null) {
        return true
    }

    if (isString(arg)) {
        return arg == ''
    }

    if (isString(arg)) {
        return arg.length < 1
    }

    if (isObject(arg)) {
        for (let pn in arg) {
            return false
        }

        return true
    }

    return false
}

export const isInteger = arg => {
    return Math.floor(arg) === arg
}
export const get = (configKey, queryParams) => {
    console.log(configKey,queryParams)
}

export const isEvent = arg => {
    if (!isObject(arg) || !arg.constructor) {
        return false
    }

    return arg.constructor.toString().toLowerCase().includes('event')
}

export const isApiResult = arg => {
    return isObject(arg) &&
        'errno' in arg &&
        'error' in arg &&
        'validationErrors' in arg &&
        'obj' in arg &&
        'list' in arg &&
        'pagination' in arg
}

export const rnd = (under, over) => {
    return parseInt(Math.random() * (over - under + 1) + under)
}

/**
 * @param len
 * @param type
 * @returns {String}
 */
export const rndString = (len, type) => {
    const seeds = [
        '',
        'abcdefghijklmnopqrstuvwxyz0123456789',
        'abcdefghijklmnopqrstuvwxyz',
        '0123456789'
    ][type]

    const sb = []

    for (let i = 1; i <= len; i++) {
        sb.push(seeds.charAt(rnd(1, seeds.length - 1)))
    }

    return sb.join('')
}

export const getSrcElementFromEvent = evt => {
    return evt.target ? evt.target : evt.srcElement
}

export const getDataSetFromDomElement = evt => {
    return isObject(dom.dataset) ? dom.dataset : {}
}

export const str2date = arg => {
    if (!isString(arg) || arg == '') {
        return null
    }

    if (!/^[1-9][0-9]{3}\-[0-9]{1, 2}\-[0-9]{1, 2}$/.test(arg)) {
        return null
    }

    const parts = arg.split('-')
    const year = parseInt(parts[0])
    const month = parseInt(parts[1]) - 1
    const date = parseInt(parts[2])

    const d1 = new Date();
    d1.setFullYear(year)
    d1.setMonth(month)
    d1.setDate(date)

    return d1
}

export const str2timestamp = arg => {
    let ts = parseInt(Date.parse(arg) / 1000)

    if (isNaN(ts)) {
        ts = parseInt(Date.parse(new Date(arg.replace(/-/g, '/'))) / 1000)
    }

    return isNaN(ts) ? 0 : ts
}

export const convertDateToString = arg => {
    if (isString(arg)) {
        return arg
    }

    if (isObject(arg) && arg.constructor == Date) {
        const year = arg.getFullYear()
        let month = parseInt(arg.getMonth(), 10) + 1
        let date = parseInt(arg.getDate(), 10)

        if (month < 10) {
            month = '0' + month
        }

        if (date < 10) {
            date = '0' + date
        }

        return `${year}-${month}-${date}`
    }

    return ''
}

export const convertTimeToString = (d1, format) => {
    if (isString(d1)) {
        return d1
    }

    if (isObject(d1) && d1.constructor == Date) {
        if (!isString(format) || format == '') {
            format = 'HH:mm:ss'
        }

        let hh = parseInt(d1.getHours(), 10)
        let mm = parseInt(d1.getMinutes(), 10)

        if (hh < 10) {
            hh = `0${hh}`
        }

        if (mm < 10) {
            mm = `0${mm}`
        }

        if (format == 'HH:mm') {
            return `${hh}-${mm}`
        }

        let ss = parseInt(d1.getSeconds(), 10)

        if (ss < 10) {
            ss = `0${ss}`
        }

        return `${hh}:${mm}:${ss}`
    }

    return ''
}

export const datetimeFormat = (p0, format) => {
    if (!isString(format) || isEmpty(format)) {
        format = 'Y-m-d H:i:s'
    }

    let d1 = null

    if (isString(p0)) {
        if (/^\d+$/.test(p0)) {
            try {
                d1 = new Date(parseInt(p0) * 1000)
            } catch (ex) {
                d1 = null
            }
        } else {
            try {
                d1 = new Date(str2timestamp(p0) * 1000)
            } catch (ex) {
                d1 = null
            }
        }
    } else {
        d1 = p0
    }

    if (!isObject(d1) || d1.constructor != Date) {
        return ''
    }

    const year = `${d1.getFullYear()}`
    const month = d1.getMonth() + 1
    const date = d1.getDate()
    const hours = d1.getHours()
    const minutes = d1.getMinutes()
    const seconds = d1.getSeconds()
    const weekDayIdx = d1.getDay()
    const weekDayNames = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
    const sb = []

    for (let i = 0; i < format.length; i++) {
        const c1 = format.charAt(i)

        switch (c1) {
            case 'Y':
                sb.push(year)
                break
            case 'y':
                sb.push(year.substring(2))
                break
            case 'm':
                sb.push(month < 10 ? `0${month}` : month)
                break
            case 'n':
                sb.push(month)
                break
            case 'd':
                sb.push(date < 10 ? `0${date}` : date)
                break
            case 'j':
                sb.push(date)
                break
            case 'H':
                sb.push(hours < 10 ? `0${hours}` : hours)
                break
            case 'i':
                sb.push(minutes < 10 ? `0${minutes}` : minutes)
                break
            case 's':
                sb.push(seconds < 10 ? `0${seconds}` : seconds)
                break
            case 'w':
                sb.push(weekDayIdx)
                break
            case 'l':
                sb.push(weekDayNames[weekDayIdx])
                break
            default:
                sb.push(c1)
                break
        }
    }

    return sb.join('')
}

export const toDecimalString = (num, n) => {
    const parts = `${num}`.split('.')

    if (!isNumber(n) || n < 1) {
        n = 2
    }

    const s1 = parts[0]

    if (parts.length < 2) {
        return s1 == '0' ? '0.00' : s1
    }

    const sb = []

    for (let i = 0; i < n && i < parts[1].length; i++) {
        sb.push(parts[1].charAt(i))
    }

    let s2 = sb.join('')
    s2 = s2.replace(/[0]+$/, '')
    s2 = `${s1}.${s2}`
    s2 = s2.replace(/\.$/, '')


    return s2 == '0' ? '0.00' : s2
}

export const delay = msecs => {
    return new Promise(resolve => setTimeout(resolve, msecs))
}

// 正则图片加class
export const formatImg = value => {
    var newContent= value.replace(/<img[^>]*>/gi,function(match,capture){
        var match = match.replace(/\<img (.*?)(?=\")/, '<img class="rt-img" $1');
        return match;
    });
    return newContent;
}

export const handleSearchParams = params => {
    const ret = Object.assign({}, params)

    if ('d1' in ret) {
        ret.d1 = convertDateToString(ret.d1)
    }

    if ('d2' in ret) {
        ret.d2 = convertDateToString(ret.d2)
    }

    if ('putawayApplyBeginDate' in ret) {
        ret.putawayApplyBeginDate = convertDateToString(ret.putawayApplyBeginDate)
    }
    if ('putawayApplyEndDate' in ret) {
        ret.putawayApplyEndDate = convertDateToString(ret.putawayApplyEndDate)
    }

    if ('payTimeD1' in ret) {
        ret.payTimeD1 = convertDateToString(ret.payTimeD1)
    }

    if ('payTimeD2' in ret) {
        ret.payTimeD2 = convertDateToString(ret.payTimeD2)
    }

    if ('refundApplyTimeD1' in ret) {
        ret.refundApplyTimeD1 = convertDateToString(ret.refundApplyTimeD1)
    }

    if ('refundApplyTimeD2' in ret) {
        ret.refundApplyTimeD2 = convertDateToString(ret.refundApplyTimeD2)
    }

    if ('refundAuditTimeD1' in ret) {
        ret.refundAuditTimeD1 = convertDateToString(ret.refundAuditTimeD1)
    }

    if ('refundAuditTimeD2' in ret) {
        ret.refundAuditTimeD2 = convertDateToString(ret.refundAuditTimeD2)
    }

    for (let pn in ret) {
        if (isBoolean(ret[pn])) {
            delete ret[pn]
            continue
        }

        if (isString(ret[pn]) && ret[pn] == '') {
            delete ret[pn]
            continue
        }

        if (isNumber(ret[pn]) && ret[pn] == -255) {
            delete ret[pn]
            continue
        }

        if (pn == 'page' && (!isNumber(ret[pn]) || ret[pn] < 2)) {
            delete ret[pn]
            continue
        }
    }

    return ret
}

export const localResource = resourceKey => {
    if (resourceKey.startsWith('https://') || resourceKey.startsWith('http://')) {
        return resourceKey
    }

    let s1 = localResourceServer

    if (s1.endsWith('/')) {
        s1 = s1.substring(0, s1.length - 1)
    }

    if (resourceKey.startsWith('/')) {
        resourceKey = resourceKey.substring(1)
    }

    return `${s1}/${resourceKey}`
}

export const qiniuResource = resourceKey => {
    if (resourceKey.startsWith('https://') || resourceKey.startsWith('http://')) {
        return resourceKey
    }

    let s1 = resourceServer

    if (s1.endsWith('/')) {
        s1 = s1.substring(0, s1.length - 1)
    }

    if (resourceKey.startsWith('/')) {
        resourceKey = resourceKey.substring(1)
    }

    return `${s1}/${resourceKey}`
}

export const qiniuImageView2 = (resourceKey, ...args) => {
    if (resourceKey.startsWith('https://') || resourceKey.startsWith('http://')) {
        return resourceKey
    }

    const url = qiniuResource(resourceKey)

    let mode = 1
    let width = 100
    let height = 100

    if (args.length == 1) {
        width = args[0]
        height = args[0]
    } else if (args.length == 2) {
        width = args[0]
        height = args[1]
    } else if (args.length > 2) {
        mode = args[0]
        width = args[1]
        height = args[2]
    }

    return `${url}?imageView2/${mode}/w/${width}/h/${height}/q/100!`
}

export const qiniuImageView3 = (value, ...args) => {
    const watermarkImage = localStorage.getItem('watermarkImage')
    let watermark = ''

    if (!isEmpty(watermarkImage)) {
        watermark = `,x-oss-process=image/watermark,image_${watermarkImage},t_80,g_nw,x_10,y_10`
    }

    if (
        !isObject(cfg) ||
        !isObject(cfg.resourceServer) ||
        !isString(cfg.resourceServer.qiniu) ||
        isEmpty(cfg.resourceServer.qiniu)
    ) {
        return value
    }

    if (!isString(value) || isEmpty(value)) {
        return value
    }

    if (value.startsWith('https://') || value.startsWith('http://')) {
        return value
    }

    let s1 = cfg.resourceServer.qiniu

    if (s1.endsWith('/')) {
        s1 = s1.substring(0, s1.length - 1)
    }

    if (value.startsWith('/')) {
        value = value.substring(1)
    }

    let mode = 1
    let width = 100
    let height = 100

    if (args.length > 2) {
        mode = args[0]
        width = args[0]
        height = args[1]
        if (!isEmpty(args[2])) {
            let watermarkImage = Base64.encode(args[2]) // ZGFua29nYWk=
            watermark = `,x-oss-process=image/watermark,image_${watermarkImage},t_80,g_nw,x_10,y_10`
        }
    } else if (args.length > 1) {
        width = args[0]
        height = args[1]
    } else if (args.length == 1) {
        width = args[0]
        height = args[0]
    }
    return `${s1}/${value}?x-oss-process=image/resize,limit_0,m_fill,w_${width},h_${height}${watermark}`
    
    
    // return `${s1}/${value}?imageView2/${mode}/w/${width}/h/${height}/q/100!${watermark}`
}

export const strTrimLeft = (str, chars, isRegexp) => {
    if (!isBoolean(isRegexp)) {
        isRegexp = false
    }

    const regexp = isRegexp ? chars : new RegExp(`^[${chars}]+`)
    return str.replace(regexp, '')
}

export const strTrimRight = (str, chars, isRegexp) => {
    if (!isBoolean(isRegexp)) {
        isRegexp = false
    }

    const regexp = isRegexp ? chars : new RegExp(`[${chars}]+$`)
    return str.replace(regexp, '')
}

export const strTrim = (str, chars, isRegexp) => {
    if (!isBoolean(isRegexp)) {
        isRegexp = false
    }

    return strTrimRight(strTrimLeft(str, chars, isRegexp), chars, isRegexp)
}

export const parseStyleObject = p0 => {
    if (!isObject(p0) || isEmpty(p0)) {
        return ''
    }

    const sb = []

    for (let pn in p0) {
        const chars = []

        for (let c of [...pn]) {
            if (c.toUpperCase() == c) {
                chars.push('-')
            }

            chars.push(c.toLowerCase())
        }

        sb.push(`${chars.join('')}: ${p0[pn]}`)
    }

    return isEmpty(sb) ? '' : `${sb.join('; ')};`
}

export default {
    isObject,
    isArray,
    isFunction,
    isNumber,
    isBoolean,
    isString,
    isEmpty,
    isInteger,
    get,
    isEvent,
    isApiResult,
    rnd,
    rndString,
    getSrcElementFromEvent,
    getDataSetFromDomElement,
    str2date,
    str2timestamp,
    convertDateToString,
    convertTimeToString,
    datetimeFormat,
    toDecimalString,
    delay,
    formatImg,
    handleSearchParams,
    localResource,
    qiniuResource,
    qiniuImageView2,
    qiniuImageView3,
    strTrimLeft,
    strTrimRight,
    strTrim,
    parseStyleObject
}



// WEBPACK FOOTER //
// ./src/libs/common_funcs.js